// extracted by mini-css-extract-plugin
export default {"container":"Item_container__DpzWC","title":"Item_title__yPrnA","content":"Item_content__PxD-f"};